import React from 'react'

function QuestionMarkIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={17}
      height={16}
      fill="none"
      {...props}
    >
      <path
        fill="#444448"
        fillRule="evenodd"
        d="M8.049 1.333a6.736 6.736 0 0 0-3.727 1.124 6.676 6.676 0 0 0-2.47 2.991A6.63 6.63 0 0 0 1.47 9.3a6.654 6.654 0 0 0 1.836 3.414 6.744 6.744 0 0 0 7.31 1.445 6.7 6.7 0 0 0 3.01-2.456 6.638 6.638 0 0 0-.835-8.417 6.743 6.743 0 0 0-4.743-1.953Zm0 12a5.39 5.39 0 0 1-2.981-.899 5.34 5.34 0 0 1-1.977-2.393 5.304 5.304 0 0 1 1.163-5.813 5.396 5.396 0 0 1 5.847-1.156 5.359 5.359 0 0 1 2.409 1.965 5.31 5.31 0 0 1-.667 6.734 5.382 5.382 0 0 1-3.794 1.562Zm0-9.333c-.623 0-1.22.246-1.66.683a2.326 2.326 0 0 0-.688 1.65.665.665 0 0 0 .67.667.673.673 0 0 0 .671-.667.996.996 0 0 1 .622-.924 1.012 1.012 0 0 1 1.096.217.998.998 0 0 1-.711 1.707.673.673 0 0 0-.671.667v1.333a.665.665 0 0 0 .67.667.673.673 0 0 0 .671-.667V8.56a2.34 2.34 0 0 0 1.314-.977 2.315 2.315 0 0 0-.445-3.022A2.35 2.35 0 0 0 8.048 4Zm.67 7.333c0 .368-.3.667-.67.667a.669.669 0 0 1-.671-.667c0-.368.3-.667.67-.667.371 0 .671.299.671.667Z"
        clipRule="evenodd"
      />
    </svg>
  )
}
export default QuestionMarkIcon
